var FontFaceObserver = require('fontfaceobserver')

// detect loading of fonts using fontfaceobserver
var Cormorant = new FontFaceObserver('Cormorant')
var SourceSansPro = new FontFaceObserver('SourceSansPro')

//Fallback condition for non Promise ready browsers
if (typeof Promise !== 'undefined') {
	//Load any fonts you want
	Promise.all([Cormorant.load(), SourceSansPro.load()]).then(function () {
		//Add class when fonts are loaded
		document.documentElement.classList.remove('fonts-loading')
		// set mark on storage for future page views
		sessionStorage.setItem('fonts-loaded', true)
	})
} else {
	document.documentElement.classList.remove('fonts-loading')
}


// WEBPACK FOOTER //
// ./src/utils/fonts-css-async.js